export const ApiHost = "https://hippo.sog.uz";
